import {
  BottomSheetComponent,
  Modal,
  NavigationConfig,
  registerBottomSheets,
  registerModals,
  registerNavigationHandlers,
} from '@betty/navigation';
import ShopScreen from '../screens/ShopScreen';
import {
  ShopInfo,
  ShopItemInfo,
  ShopSort,
  VerificationPending,
  MysteryBoxInfo,
} from '../bottomSheets';
import ShopMysteryBoxScreen from '../screens/ShopMysteryBoxScreen';
import { ComponentProps, JSXElementConstructor } from 'react';

export const NAVIGATION_CONFIG: NavigationConfig<AppNavigatorParamsList> = {
  FULL_SCREENS: [
    {
      name: 'Shop',
      options: {},
      component: ShopScreen,
    },
  ],
  FULL_SCREEN_MODALS: [],
  FULL_SCREEN_MODALS_TRANSPARENT: [
    {
      name: 'ShopMysteryBox',
      options: {},
      component: ShopMysteryBoxScreen,
    },
  ],
};

const bottomSheets = {
  ShopInfo,
  ShopSort,
  ShopItemInfo,
  VerificationPending,
  MysteryBoxInfo,
};

const modals = {
  ShopMysteryBox: ShopMysteryBoxScreen,
};

registerBottomSheets('shop', bottomSheets);
registerModals('shop', modals);

declare global {
  interface RegisteredBottomSheets {
    shop: Record<keyof typeof bottomSheets, BottomSheetComponent>;
  }

  interface RegisteredModals {
    shop: {
      [K in keyof typeof modals]: JSXElementConstructor<
        ComponentProps<(typeof modals)[K]>
      >;
    };
  }
}

registerNavigationHandlers<AppNavigatorParamsList, 'Shop' | 'ShopMysteryBox'>({
  Shop(navigate) {
    navigate('/shop');
  },
  ShopMysteryBox(_, params) {
    const { options } = params ?? {};

    Modal.open({
      namespace: 'shop',
      type: 'ShopMysteryBox',
      options: {
        variant: 'transparent',
        hideHeader: true,
        ...options,
      },
    });
  },
});
